<template>
  <v-dialog :value="value" @input="input" :width="500" content-class="version-modal" ref="dialog">
    <v-card>
      <v-card-title class="version-title">
        <p>Management Console</p>
        <p>Software version</p>
      </v-card-title>
      <v-card-text class="versions-list-outer">
        <div>
          <strong>Authenticator</strong>
          <ul>
            <li>{{ authenticatorVersion }}</li>
          </ul>
        </div>
        <div>
          <strong>Backends</strong>
          <ul class="versions-list">
            <li>Edval Cloud:</li>
            <multi-version-item :value="cloudVersion"/>
            <li>School manager:</li>
            <version-item :value="enterpriseVersion"/>
            <li>Messaging platform</li>
            <version-item :value="messagingVersion"/>
            <li>Zoho integrations</li>
            <version-item :value="zohoVersion"/>
            <li>Domains API</li>
            <version-item :value="domainsapiVersion"/>
          </ul>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import MultiVersionItem from './MultiVersionItem';
  import VersionItem from './VersionItem';

  export default {
    components: { MultiVersionItem, VersionItem },
    props: {
      value: Boolean
    },
    data() {
      return {
        frontendVersion: this.$configuration.build.version,
        authenticatorVersion: null,
        cloudVersion: this.$services.cloud.map((s) => null),
        enterpriseVersion: null,
        zohoVersion: null,
        domainsapiVersion: null,
        messagingVersion: null
      };
    },
    methods: {
      input(v) {
        if (!v) {
          this.authenticatorVersion = null;
          this.cloudVersion = this.$services.cloud.map((s) => null);
          this.enterpriseVersion = null;
          this.zohoVersion = null;
          this.domainsapiVersion = null;
          this.messagingVersion = null;
        }
        this.$emit('input', v);
      },
      getServiceVersion(serviceName) {
        if (this[serviceName + 'Version']) {
          return Promise.resolve(this[serviceName + 'Version']);
        } else {
          return this[
            'get' + serviceName.charAt(0).toUpperCase() + serviceName.substr(1) + 'Version'
          ]();
        }
      },
      getAuthenticatorVersion() {
        return this.$services.authenticator.get('/version')
          .then((res) => this.authenticatorVersion = res.data.data);
      },
      getCloudVersion() {
        return this.$services.cloud.map((s, i) =>
          s.get('/info/appVersion')
            .then((response) => this.$set(this.cloudVersion, i, response.data.data))
        );
      },
      getEnterpriseVersion() {
        return this.$services.enterprise.get('/info/appVersion')
          .then((response) => this.enterpriseVersion = response.data.data);
      },
      getZohoVersion() {
        return this.$services.zoho.get('/version')
          .then((res) => this.zohoVersion = res.data.version);
      },
      getDomainsapiVersion() {
        return this.$services.domainsapi.get('/version')
          .then((res) => this.domainsapiVersion = res.data.version);
      },
      getMessagingVersion() {
        return this.$services.messaging.get('/version')
          .then((res) => this.messagingVersion = res.data.version);
      }
    },
    watch: {
      value(v) {
        // Vuetify doesn't give us a way to add classes/styles directly
        this.$nextTick(() => this.$refs.dialog.$refs.content.classList.add('dialog-top'));
        if (v) {
          Promise.all([
            this.getServiceVersion('authenticator'),
            this.getCloudVersion(),
            this.getServiceVersion('enterprise'),
            this.getServiceVersion('zoho'),
            this.getServiceVersion('domainsapi'),
            this.getServiceVersion('messaging')
          ]).catch(this.$defaultHandlerHttp);
        }
      }
    }
  };
</script>

<style lang="less">
  @import '../../../../style/theme.less';

  .dialog-top.v-dialog__content {
    align-items: flex-start;
  }

  .version-modal {
    cursor: default;
    overflow: visible;

    .version-title {
      background: @header-background;
      color: @header-text-colour;
      padding: 7px;

      p {
        width: 100%;
        text-align: center;
        margin: 0;
      }
    }

    .versions-list-outer {
      text-align: left;

      div:not(:last-child) {
        margin-bottom: 15px;
      }

      ul {
        list-style: none;

        li {
          margin-left: 20px;
        }

        &.versions-list {
          overflow: auto;

          > li {
            float: left;
            width: 40%;
          }
        }
      }
    }
  }
</style>
